module.exports = __webpack_public_path__ + "img/hr.99bc4498.svg";